<template>
  <div class="box">
    <div class="content defBorderRadius">
      <div class="content_top">
        <div class="title">我的购买</div>
      </div>
      <div class="content_search">
        <el-input
          v-model="listParm.keyword"
          style="width: 258px"
          placeholder="请输入搜索内容..."
        ></el-input>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </div>
      <div class="content_search">
        <category v-model="listParm.categoryId" @change="onSearch" />
      </div>
      <div class="content_main">
        <div class="card" v-show="!listLoading">
          <thinktankItem
            :itemData="item"
            v-for="item in list"
            :key="item.tempId"
            @yulan="yulan(item)"
            @xiazai="xiazai(item)"
          />
        </div>
        <empty v-if="list.length === 0" />
        <div class="pagination">
          <el-pagination
            :current-page="parm.current"
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="parm.size"
            background
            layout="total, prev, pager, next, jumper"
            :total="parm.total"
            @size-change="sizeChange"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <thinktanPopup ref="thinktanPopupRef" :showMask="false" />
  </div>
</template>

<script>
import thinktankItem from "./thinktankItem.vue";
import getList from "@/mixins/getList";
import thinktanPopup from "./thinktanPopup.vue";
import empty from "@/components/empty.vue";
import category from "./category.vue";
export default {
  mixins: [getList],
  components: {
    thinktankItem,
    thinktanPopup,
    empty,
    category,
  },
  data() {
    return {
      listParm: {
        keyword: "",
        categoryId: null,
      },
    };
  },
  mounted() {
    const { tempId, downloadUrl } = this.$route.query;
    if (downloadUrl) {
      const url = decodeURIComponent(downloadUrl);
      this.xiazai({ url });
      this.$router.replace({
        path: this.$route.path,
      });
    }
  },
  methods: {
    listApi(parm) {
      return this.$api.getContractTempMine({ ...parm, ...this.listParm });
    },
    yulan(item) {
      this.$refs.thinktanPopupRef.onShow(item);
    },
    xiazai(item) {
      this.$utils.downloadFile(this.$oss + item.url, item.subject);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;

  .content {
    background: #ffffff;
    &_top {
      padding-left: 16px;
      display: flex;
      align-items: center;
      height: 60px;
      gap: 16px;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #3d3d3d;
      }
    }
    &_search {
      height: 50px;
      display: flex;
      padding-left: 16px;
      gap: 10px;
      align-items: center;
      &::v-deep {
        @include inputStyle;
      }
    }
    &_main {
      padding: 16px;
      .card {
        display: flex;
        flex-wrap: wrap;
        grid-template-columns: repeat(5, 1fr); /* 固定 5 列 */
        gap: 16px; /* 行列间距 */
      }
    }
  }
  .pagination {
    @include paginationStyle;
  }
}
</style>
